import { useEffect, useState } from 'react';
import { api } from '../api/client';

/**
 * Carica il layout di una pagina dal backend.
 * Se non è stato salvato nulla, ritorna `defaultBlocks` (definito dal codice).
 * Fallisce silenziosamente in caso di backend offline (il sito mostra il default).
 */
export function useLayout(page, defaultBlocks) {
  const [blocks, setBlocks] = useState(defaultBlocks);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    api.getLayout(page)
      .then((d) => {
        if (!alive) return;
        if (Array.isArray(d?.blocks) && d.blocks.length > 0) setBlocks(d.blocks);
        else setBlocks(defaultBlocks);
      })
      .catch(() => { /* offline → default */ })
      .finally(() => alive && setLoaded(true));
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return { blocks, loaded };
}
